import React from "react";
import Event from "../event";

export default function AsianGameEventTemplate () {
    let {item, game, filter} = this.props;
    try {
        let market = game.groupedMarkets[filter + "_" + item.market], events = {},
            eventsObj = market.event;
        eventsObj && Object.keys(eventsObj).map(id => {
            events[eventsObj[id].type] = eventsObj[id];
        });
        return <li className="factor-m" key={item.market}><Event key={filter} showBase event={events[item.side]}
                                                                 price={events[item.side]?.price}
                                                                 game={game} market={market}/></li>;
    } catch (e) {
        return <li className="factor-m" key={item.market}><span/></li>;
    }
};